import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ModalData {
  title: string;
  message: string;
  isError?: boolean;
  confirmText?: string;
  cancelText?: string;
  // New properties for status update
  statusOptions?: string[];
  initialStatus?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalSubject = new Subject<ModalData | null>();
  modalState$ = this.modalSubject.asObservable();

  private confirmationSubject = new Subject<any>(); // Changed to any

  open(data: ModalData): Observable<any> { // Changed to any
    this.modalSubject.next(data);
    this.confirmationSubject = new Subject<any>();
    return this.confirmationSubject.asObservable();
  }

  close() {
    this.modalSubject.next(null);
    // Asegurarse de que cualquier suscriptor de confirmación sea notificado
    if (!this.confirmationSubject.closed) {
      this.confirmationSubject.next(false); // Emite 'false' por defecto al cerrar
      this.confirmationSubject.complete();
    }
  }

  confirm(decision: any) { // Changed to any
    this.confirmationSubject.next(decision);
    this.confirmationSubject.complete();
    this.modalSubject.next(null); // Cierra el modal
  }
}
